import ApplyBonusConfig from '../ActionConfigs/ApplyBonusConfig/ApplyBonusConfig'
import ApplyExtraFeeConfig from '../ActionConfigs/ApplyExtraFeeConfig/ApplyExtraFeeConfig'
import BlockOptionForOrderConfig from '../ActionConfigs/BlockOptionForOrderConfig/BlockOptionForOrderConfig'
import BlockOptionForProductConfig from '../ActionConfigs/BlockOptionForProductConfig/BlockOptionForProductConfig'
import DisableInstantConfig from '../ActionConfigs/DisableInstantConfig/DisableInstantConfig'
import DisableRefundMethodsConfig from '../ActionConfigs/DisableRefundMethodsConfig/DisableRefundMethodsConfig'
import DisplayConsentModalConfig from '../ActionConfigs/DisplayConsentModalConfig/DisplayConsentModalConfig'
import DisplayMessageConfig from '../ActionConfigs/DisplayMessageConfig/DisplayMessageConfig'
import ExtendReturnWindowConfig from '../ActionConfigs/ExtendReturnWindowConfig/ExtendReturnWindowConfig'
import ForceExchangeOrderTriggerConfig from '../ActionConfigs/ForceExchangeOrderTriggerConfig/ForceExchangeOrderTriggerConfig'
import ForceRefundMethodConfig from '../ActionConfigs/ForceRefundMethodConfig/ForceRefundMethodConfig'
import ForceRefundTriggerConfig from '../ActionConfigs/ForceRefundTriggerConfig/ForceRefundTriggerConfig'
import PutRefundOnHoldConfig from '../ActionConfigs/PutRefundOnHoldConfig/PutRefundOnHoldConfig'
import PutRequestOnHoldConfig from '../ActionConfigs/PutRequestOnHoldConfig/PutRequestOnHoldConfig'
import TagsConfig from '../ActionConfigs/TagsConfig/TagsConfig'
import { actionTypeValues } from '../constants'

const ActionConfigRenderer = ({
  actionType,
  config,
  onChangeConfig,
  disabled,
  currencyOptions,
  currencies,
  storeCurrencyCode,
  productTypes,
  productCategories,
  productCollections,
  errors = [],
  availableIssueRefundStatuses,
  availableIssueExchangeStatuses,
}) => {
  if (actionType === actionTypeValues.blockOrderOptions) {
    return (
      <BlockOptionForOrderConfig config={config} onChangeConfig={onChangeConfig} disabled={disabled} errors={errors} />
    )
  }

  if (actionType === actionTypeValues.blockItemOptions) {
    return (
      <BlockOptionForProductConfig
        config={config}
        onChangeConfig={onChangeConfig}
        disabled={disabled}
        currencies={currencies}
        storeCurrencyCode={storeCurrencyCode}
        productTypes={productTypes}
        productCategories={productCategories}
        productCollections={productCollections}
        errors={errors}
      />
    )
  }

  if (actionType === actionTypeValues.disableInstant) {
    return <DisableInstantConfig config={config} onChangeConfig={onChangeConfig} disabled={disabled} errors={errors} />
  }

  if (actionType === actionTypeValues.extendWindow) {
    return (
      <ExtendReturnWindowConfig config={config} onChangeConfig={onChangeConfig} disabled={disabled} errors={errors} />
    )
  }

  if (actionType === actionTypeValues.putOnHold) {
    return (
      <PutRequestOnHoldConfig config={config} onChangeConfig={onChangeConfig} disabled={disabled} errors={errors} />
    )
  }

  if (actionType === actionTypeValues.putRefundOnHold) {
    return <PutRefundOnHoldConfig config={config} onChangeConfig={onChangeConfig} disabled={disabled} errors={errors} />
  }

  if (actionType === actionTypeValues.applyBonus) {
    return (
      <ApplyBonusConfig
        config={config}
        onChangeConfig={onChangeConfig}
        disabled={disabled}
        currencies={currencies}
        storeCurrencyCode={storeCurrencyCode}
        productTypes={productTypes}
        productCategories={productCategories}
        productCollections={productCollections}
        errors={errors}
      />
    )
  }

  if (actionType === actionTypeValues.applyExtraFee) {
    return (
      <ApplyExtraFeeConfig
        config={config}
        onChangeConfig={onChangeConfig}
        disabled={disabled}
        currencyOptions={currencyOptions}
        currencies={currencies}
        storeCurrencyCode={storeCurrencyCode}
        productTypes={productTypes}
        productCategories={productCategories}
        productCollections={productCollections}
        errors={errors}
      />
    )
  }

  if (actionType === actionTypeValues.forceRefundMethod) {
    return (
      <ForceRefundMethodConfig config={config} onChangeConfig={onChangeConfig} disabled={disabled} errors={errors} />
    )
  }

  if (actionType === actionTypeValues.forceRefundTrigger) {
    return (
      <ForceRefundTriggerConfig
        config={config}
        onChangeConfig={onChangeConfig}
        disabled={disabled}
        errors={errors}
        availableIssueRefundStatuses={availableIssueRefundStatuses}
      />
    )
  }

  if (actionType === actionTypeValues.forceExchangeOrderTrigger) {
    return (
      <ForceExchangeOrderTriggerConfig
        config={config}
        onChangeConfig={onChangeConfig}
        disabled={disabled}
        errors={errors}
        availableIssueExchangeStatuses={availableIssueExchangeStatuses}
      />
    )
  }

  if (actionType === actionTypeValues.disableRefundMethods) {
    return (
      <DisableRefundMethodsConfig config={config} onChangeConfig={onChangeConfig} disabled={disabled} errors={errors} />
    )
  }

  if (actionType === actionTypeValues.addTags) {
    return <TagsConfig config={config} onChangeConfig={onChangeConfig} disabled={disabled} errors={errors} />
  }

  if (actionType === actionTypeValues.displayMessage) {
    return (
      <DisplayMessageConfig
        config={config}
        onChangeConfig={onChangeConfig}
        disabled={disabled}
        currencies={currencies}
        storeCurrencyCode={storeCurrencyCode}
        productTypes={productTypes}
        productCategories={productCategories}
        productCollections={productCollections}
        errors={errors}
      />
    )
  }

  if (actionType === actionTypeValues.displayConsentModal) {
    return (
      <DisplayConsentModalConfig config={config} onChangeConfig={onChangeConfig} disabled={disabled} errors={errors} />
    )
  }

  return null
}

export default ActionConfigRenderer
